import { Layer } from "ol/layer";
import { Source } from "ol/source";
import { LayerDefaults, LayerTitle } from "../types/layers";
import { readMapSettings } from "./localMapSettings";

interface CreateLayerInputs {
  source: Source;
  layer: Layer;
  title: LayerTitle;
}

export const createLayer = ({
  source,
  layer,
  title,
}: CreateLayerInputs): Layer => {
  layer.setSource(source);
  layer.set("title", title);
  layer.setZIndex(
    readMapSettings("layers", title)?.zIndex ?? LayerDefaults[title].zIndex,
  );
  layer.setVisible(
    readMapSettings("layers", title)?.visible ?? LayerDefaults[title].visible,
  );
  const maxZoom = LayerDefaults[title]?.maxZoom;
  if (maxZoom) {
    layer.setMaxZoom(maxZoom);
  }
  const minZoom = LayerDefaults[title]?.minZoom;
  if (minZoom) {
    layer.setMinZoom(minZoom);
  }
  return layer;
};
